const MOBILE_AGENTS = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
/**
 * 모바일 디바이스인지 확인하는 함수
 */
export const isMobileDevice = (userAgent: string, userDevice?: string | undefined): boolean => {
  return MOBILE_AGENTS.test(userAgent || '') || userDevice === 'MO';
};
